module.exports = {"clubUnionHead":"Clubs & Unions","clubs":{"club1":{"clubNum":1,"clubName":"Tbilisi Hippodrome","clubLink":""},"club2":{"clubNum":2,"clubName":"Akhalubani Equestrian Club","clubLink":""}}}


//////////////////
// WEBPACK FOOTER
// ./src/components/EN-vers/menu/ClubUnion.json
// module id = gGxk
// module chunks = 0